import { useEffect, useState } from "react";
import { api } from "../utils/api";

const SOURCES = {
  subscription: { endpoint: "v1/membership-analytics/price-changes", field: "subscriptionIds" },
  customer: { endpoint: "v1/membership-analytics/price-changes/by-customer", field: "customerIds" },
};

/**
 * Loads Stripe price change history for the IDs on screen, keyed by ID.
 * kind is "subscription" or "customer". Price history only adds badges, so
 * a failed request leaves an empty map. Responses for an older set of IDs
 * are dropped.
 */
export default function usePriceChanges(kind, ids, enabled = true) {
  const [priceChanges, setPriceChanges] = useState({});
  const key = enabled ? [...new Set((ids || []).filter(Boolean).map(String))].join(",") : "";

  useEffect(() => {
    const source = SOURCES[kind];
    if (!source || !key) {
      setPriceChanges({});
      return undefined;
    }
    let current = true;
    api(source.endpoint, "POST", { [source.field]: key.split(",") })
      .then((response) => {
        if (!current) return;
        setPriceChanges(response.data.success ? response.data.data || {} : {});
      })
      .catch((error) => {
        if (!current) return;
        console.error("Failed to load price changes", error);
        setPriceChanges({});
      });
    return () => {
      current = false;
    };
  }, [kind, key]);

  return priceChanges;
}
